import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const API_BASE = "https://backend.alephmedia.ro/api";

function RegisterInvite() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    async function checkToken() {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(`${API_BASE}/invitations/${token}`);
        const data = await res.json();
        if (res.ok && data.success) {
          setIsValid(true);
        } else {
          setError(data.message || 'Token invalid');
        }
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    }
    if (token) checkToken();
  }, [token]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    if (password !== confirmPassword) {
      setError('Parolele nu se potrivesc');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/invitations/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, name, email, password })
      });
      const data = await res.json();
      if (!res.ok || !data.success) {
        // Mesaj explicit din backend pentru 404/409/422
        if (res.status === 404) {
          throw new Error(data.message || 'Token invalid sau expirat');
        }
        if (res.status === 409) {
          throw new Error(data.message || 'Conflict: invitație epuizată sau email deja folosit');
        }
        if (res.status === 422) {
          let msg = data.message || 'Eroare de validare';
          if (data.errors) {
            const parts = [];
            Object.keys(data.errors).forEach((k) => {
              const v = data.errors[k];
              if (Array.isArray(v)) {
                v.forEach((m) => parts.push(`${k}: ${m}`));
              } else if (typeof v === 'string') {
                parts.push(`${k}: ${v}`);
              }
            });
            if (parts.length) msg = parts.join('\n');
          }
          throw new Error(msg);
        }
        throw new Error(data.message || 'Eroare la înregistrare');
      }
      // Salvăm token-ul și user-ul și navigăm direct la v3.0
      if (data.token) localStorage.setItem('authToken', data.token);
      if (data.user) {
        // Salvăm toate câmpurile de subscripție pentru a evita redirecționarea la plată
        const userData = {
          id: data.user.id,
          name: data.user.name,
          email: data.user.email,
          subscription_kind: data.user.subscription_kind,
          subscription_type: data.user.subscription_type || 'b2b',
          subscription_status: data.user.subscription_status || 'active',
          subscription_expires_at: data.user.subscription_expires_at || null,
          details: data.user.details
        };
        localStorage.setItem('userData', JSON.stringify(userData));
      }
      // Ștergem flag-ul de guest timeout dacă există
      localStorage.removeItem('v3_guest_timeout');
      setStatus('Înregistrare reușită! Redirecționare...');
      setTimeout(() => navigate('/v3.0'), 1000);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  if (loading) return <p>Se încarcă...</p>;
  if (!isValid) return <p>{error || 'Token invalid sau indisponibil'}</p>;

  return (
    <div className="auth-wrapper">
      <div className="auth-container">
        <div className="auth-logo">
          <a href="/">
            <img src="/assets/img/logo-aleph-rosu.png" alt="Aleph" />
          </a>
        </div>
        <h1 className="auth-title">Înregistrare pe bază de invitație</h1>
        <form onSubmit={handleSubmit}>
          <input className="form-field" type="text" placeholder="Nume complet" value={name} onChange={e => setName(e.target.value)} required />
          <input className="form-field" type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
          <input className="form-field" type="password" placeholder="Parolă" value={password} onChange={e => setPassword(e.target.value)} required />
          <input className="form-field" type="password" placeholder="Confirmă parola" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required />
          <button className="form-submit" type="submit" disabled={loading}>{loading ? 'Se procesează…' : 'Creează cont'}</button>
          {error && <p className="error">{error}</p>}
          {status && <p>{status}</p>}
        </form>
      </div>
    </div>
  );
}

export default RegisterInvite;


